import {useTranslation} from '@hconnect/uikit'
import {DashboardCard, CardHeader, ControlledInput} from '@hm/fundamental'
import React from 'react'
import {useFormContext, Controller} from 'react-hook-form'

import {SlotManagementConfig} from '../types/SlotManagementConfig'

// Auto Confirm Lead Time validation constants
const AUTO_CONFIRM_LEAD_TIME_VALIDATION = {
  MIN: 0,
  MAX: 20,
  STEP: 1
} as const

export const SlotManagementSettings = () => {
  const {t} = useTranslation()
  const formMethods = useFormContext<SlotManagementConfig>()

  return (
    <DashboardCard>
      <CardHeader>
        {t('configurations.hconnect.slotManagement.configurationDetails.settingsTitle')}
      </CardHeader>

      {/* Form Content */}
      <div className="flex flex-col gap-4">
        <Controller
          name="autoConfirmLeadTime"
          control={formMethods.control}
          rules={{
            min: {
              value: AUTO_CONFIRM_LEAD_TIME_VALIDATION.MIN,
              message: t(
                'configurations.hconnect.slotManagement.configurationDetails.validation.minValue',
                {minValue: AUTO_CONFIRM_LEAD_TIME_VALIDATION.MIN}
              )
            },
            max: {
              value: AUTO_CONFIRM_LEAD_TIME_VALIDATION.MAX,
              message: t(
                'configurations.hconnect.slotManagement.configurationDetails.validation.maxValue',
                {maxValue: AUTO_CONFIRM_LEAD_TIME_VALIDATION.MAX}
              )
            }
          }}
          render={({field: controllerField, fieldState}) => (
            <div className="max-w-md">
              <ControlledInput
                {...controllerField}
                onChange={(event) => {
                  const value = event.target.value
                  // Convert empty string to undefined, otherwise parse as number
                  // Fundamental input are working only with string unfortunetelly
                  const numberValue = value === '' ? undefined : Number(value)
                  controllerField.onChange(numberValue)
                }}
                value={String(controllerField.value ?? '')}
                label={t(
                  'configurations.hconnect.slotManagement.configurationDetails.autoConfirmLeadTimeLabel'
                )}
                type="number"
                error={fieldState.error?.message}
                isTouched={fieldState.isTouched}
                data-test-id="slot-management-configurations-auto-confirm-lead-time"
              />
            </div>
          )}
        />
      </div>
    </DashboardCard>
  )
}
